import { Filter } from './filter.js';
export class HueSaturationFilter extends Filter {
    _hue: number;
    _saturation: number;
    _luminosity: number;
    minHue: number;
    maxHue: number;
    minSaturation: number;
    maxSaturation: number;
    minLuminosity: number;
    maxLuminosity: number;

    constructor(gl: any, width: number, height: number) {
        super(gl, width, height, 'hueSaturation', 'Teinte/Saturation');
        this.reset();
    }

    get hue() {
        return this._hue;
    }

    set hue(value) {
        var self = this;
        self._hue = value;
        self._touch = true;
    }

    get saturation() {
        return this._saturation;
    }

    set saturation(value) {
        var self = this;
        self._saturation = value;
        self._touch = true;
    }

    get luminosity() {
        return this._luminosity;
    }

    set luminosity(value) {
        var self = this;
        self._luminosity = value;
        self._touch = true;
    }

    reset() {
        var self = this;
        self._touch = true;
        self._hue = 0;
        self.minHue = -180;
        self.maxHue = 180;

        self._saturation = 0;
        self.minSaturation = -100;
        self.maxSaturation = 100;

        self._luminosity = 0;
        self.minLuminosity = -100;
        self.maxLuminosity = 100;
    }

}
